
import { defineComponent, ref, Ref, inject, computed, onMounted } from "vue";
import { store } from "@/store";
import CloseSVG from "@/components/CloseSVG.vue";
import { ActionTypes } from "@/store/actions";
import { LabelShapes, CurrentLabel } from "@/types";

export default defineComponent({
  components: {
    CloseSVG,
  },
  setup() {
    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    const labelShapes = computed<LabelShapes[]>(() =>
      store.getters.labelShapes.sort((a: LabelShapes, b: LabelShapes) => {
        return a.editor_position! - b.editor_position!;
      })
    );

    const currentLabel = computed<CurrentLabel>(() => store.getters.currentLabel);
    const currentLabelShape = computed<LabelShapes>(
      () =>
        labelShapes.value.find((label: LabelShapes) => label.id === currentLabel.value.shape_id)!
    );

    onMounted(() => {
      const foundShape = labelShapes.value.find(
        (label: LabelShapes) => label.id === currentLabel.value.shape_id
      );

      if (foundShape && foundShape.id) {
        const shapeContainer = document.getElementById(foundShape.id.toString());

        if (shapeContainer) {
          shapeContainer.style.background = "#0096ff15";

          const listContainer = document.getElementById("modal-shapes-container");

          if (listContainer) {
            const sizeContainerBoundingRect = shapeContainer.getBoundingClientRect();
            const listContainerBoundingRect = listContainer.getBoundingClientRect();

            // prettier-ignore
            listContainer.scroll(0, sizeContainerBoundingRect.top - listContainerBoundingRect.top - sizeContainerBoundingRect.height / 2);
          }
        }
      }
    });

    const currentlySelectedShapeId = ref(currentLabel.value.shape_id);
    const selectedLabelShape = ref({} as LabelShapes);

    const validateTarget = (target: EventTarget | null): target is HTMLInputElement => {
      return target !== null && target !== undefined;
    };

    const handleInput = (target: EventTarget | null, id: number): void => {
      if (validateTarget(target)) {
        const selectedShape = target.value;
        const foundShape = labelShapes.value.find(
          (label: LabelShapes) => label.name === selectedShape
        );

        if (foundShape) {
          const shapeContainer = document.getElementById(id.toString());
          const prevShapeContainer = document.getElementById(
            currentlySelectedShapeId.value.toString()
          );

          if (shapeContainer && prevShapeContainer) {
            prevShapeContainer.style.background = "";

            shapeContainer.style.background = "#0096ff15";
            currentlySelectedShapeId.value = id;
          }

          selectedLabelShape.value = foundShape;
        }
      }
    };

    const changeLabelShapes = () => {
      store.dispatch(ActionTypes.CHANGE_LABEL_SHAPE, selectedLabelShape.value);
      closeModal();
    };

    return {
      closeModal,
      bounceTransition,
      fadeTransition,
      labelShapes,
      currentLabel,
      currentLabelShape,
      selectedLabelShape,
      handleInput,
      changeLabelShapes,
    };
  },
});
